<template>
  <div class="bg" :style="{ fontFamily: fonts,background: 'url(' + bgUrl + ') no-repeat center / 100% 100%' }">
    <home-header @changeFont="changeF"></home-header>
    <div class="bgbody">
      <div class="center">
        <div class="faceRegister">
          <div class="header">请出示二维码签到，谢谢！</div>
          <div class="videoBox">
            <!-- <img src="../assets/code.png" alt=""> -->
            <div class="playbox" id="bcid">
              <div class="qrline"></div>
              <!-- <img class="qrbg bg2" src="../assets/scanline.gif" /> -->
              <img
                class="qrbg"
                src="../assets/qrbg.png"
                :style="{ width: vWidth + 'px', height: vHeight + 'px' }"
              />
              <video
                id="qrcode"
                width="100%"
                height="100%"
                ref="videoCode"
                preload
                autoplay
                loop
                muted
                v-show="bol1"
              ></video>
              <canvas ref="qrcodeDOM" id="qrcode_detect"></canvas>
            </div>
          </div>
          <div class="registerBottom">
            <div class="imgtext">{{ isdetected }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeHeader from "./header";
import { Toastinit } from "@/utils/toast";
import { allLists, signOnByQRCode, getMeetModel } from "@/utils/request";
import QrCode from "qrcode-decoder";
export default {
  components: {
    HomeHeader
  },
  data() {
    return {
      fonts: "",
      timeClock: null,
      video: null,
      bol1: true,
      id: "",
      meetingId: "",
      meetingName: "",
      meetingtimer: null,
      equipmentName: "",
      startTime: "",
      thisCodeId: "",
      faceImg: "",
      count: 0,
      count2: 0,
      imgSrc: "",
      isdetected: "将二维码放入框内进行扫描",
      videoEl: {},
      canvasEL: {},
      vWidth: "",
      vHeight: "",
      trackCcv: false,
      trackTracking: false,
      autoCaptureTrackTraking: false,
      rect: {},
      isAready: false,
      // isShowQcode: true,
      erweimaId: "",
      tracker: null,
      trackTask: null,
      userMediaConstraints: {
        audio: false,
        video: {
          // 摄像头翻转
          facingMode: "user"
        }
      },
      bgUrl:''
    };
  },
  methods: {
    // getMeetModels() {
    //   getMeetModel().then(res => {
    //     if (Number(res.code) === 0) {
    //       this.fonts = res.data.fontStyle;
    //     }
    //   });
    // },
    // 会议室信息列表
    allLists() {
      let params = {
        meetingId: this.meetingId
      };
      allLists(params).then(res => {
        if (res.code == 0) {
          this.startTime = res.data.pageInfoList.list[0].startTime;
          this.erweimaId = res.data.pageInfoList.list[0].id;
          // if(this.isShowQcode){
          //     this.creatQrCode(res.data.pageInfoList.list[0].id);
          // }
          if (
            this.$route.query.homeTo &&
            this.$route.query.homeTo !== undefined
          ) {
            let _this = this;
            this.timer = setInterval(() => {
              let curdate = new Date().getTime();
              let startSeconds = new Date(this.startTime).getTime();
              if (startSeconds < curdate) {
                //会议开始了
                clearInterval(_this.timer);
                _this.$router.push({
                  path: "/advertising",
                  query: {
                    equipmentName: this.equipmentName,
                    meetingId: this.meetingId,
                    name: this.name,
                    meetingName: this.meetingName
                  }
                });
              }
            }, 1000);
          }
        }
      });
    },
    async init() {
      let w = document.getElementsByClassName("playbox")[0].clientWidth;
      // let faceCanvas = document.getElementById('faceImgcanvas')
      // let facecxt = faceCanvas.getContext('2d')
      let qrcodeCanvas = document.getElementById("qrcode_detect");
      let qrcodecxt = qrcodeCanvas.getContext("2d");
      // this.videoEl = this.$refs.videoDom
      this.videocodeEl = this.$refs.videoCode;
      this.videocodeEl.width = w * 0.45;
      this.videocodeEl.height = w * 0.45;

      this.vWidth = w * 0.45;
      this.vHeight = w * 0.45;
      qrcodeCanvas.width = w * 0.45;
      qrcodeCanvas.height = w * 0.45;

      await navigator.mediaDevices
        .getUserMedia(this.userMediaConstraints)
        .then(this.getMediaStreamSuccess)
        .catch(this.getMediaStreamError);
      await this.onPlay();
    },
    async onPlay() {
      // debugHelper.log('onPlay')
      this.isdetected = "将二维码放入框内进行扫描";
      // this.onTrackTracking()
      let _this = this;
      if (this.meetingtimer) {
        clearInterval(this.meetingtimer);
      } else {
        this.meetingtimer = setInterval(function() {
          _this.takePhoto();
        }, 300);
      }
    },
    takePhoto() {
      let w = document.getElementsByClassName("playbox")[0].clientWidth;
      let qrcodeCanvas = document.createElement("canvas");
      let qrcodecxt = qrcodeCanvas.getContext("2d");
      qrcodeCanvas.width = w * 0.55;
      qrcodeCanvas.height = w * 0.55;
      qrcodecxt.drawImage(
        this.videocodeEl,
        0,
        0,
        this.videocodeEl.width,
        this.videocodeEl.height
      );
      this.imgSrc = qrcodeCanvas.toDataURL("image/png");
      const file = this.base64ImgtoFile(this.imgSrc);
      // 获取临时路径 chrome有效，其他浏览器的方法请自行查找
      const url = window.webkitURL.createObjectURL(file);
      // 初始化
      const qr = new QrCode();
      // // 解析二维码，返回promise
      // console.log(url);
      qr.decodeFromImage(url).then(res => {
        //打印结果为 解析出来的 二维码地址
        // console.log(res);
        if (res.data && res.data !== undefined) {
          signOnByQRCode({
            orderId: this.id,
            QRCode: res.data
          }).then(res => {
            if (Number(res.code) === 0) {
              // this.isdetected = res.data
              // this.$message.success(res.data)
              this.$router.push({
                path: "/registerOk",
                query: {
                  equipmentName: this.equipmentName,
                  meetingId: this.meetingId,
                  meetingName: this.name,
                  meetingName: this.meetingName,
                  id: this.id
                }
              });
            } else {
              // this.isdetected = res.msg;
              // this.$message.error(res.msg);
              Toastinit({
                time: 2000,
                message: res.msg,
                type: "error"
              });
              setTimeout(() => {
                this.isdetected = "将二维码放入框内进行扫描";
              }, 3000);
            }
          });
        }
      });
    },
    base64ImgtoFile(dataurl, filename = "file") {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let suffix = mime.split("/")[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime
      });
    },
    getMediaStreamSuccess(stream) {
      // window.stream = stream // make stream available to browser console
      try {
        //兼容webkit内核浏览器
        var CompatibleURL = window.URL || window.webkitURL;
        //将视频流设置为video元素的源
        // this.videocodeEl.src = CompatibleURL.createObjectURL(stream);   // 此处的代码将会报错  解决的办法是将video的srcObject属性指向stream即可
        this.videocodeEl.srcObject =
          stream || CompatibleURL.createObjectURL(stream);
      } catch (error) {
        this.videocodeEl.src = window.URL.createObjectURL(stream);
      }
    },
    changeF(font) {
      this.fonts = font;
    },
    // 视频媒体流失败
    getMediaStreamError(error) {
      // alert('视频媒体流获取错误' + error)
    }
  },
  mounted() {
    // console.log(this.$route.query.meetingId)
    this.id = this.$route.query.id;
    this.equipmentName = this.$route.query.equipmentName;
    this.meetingId = this.$route.query.meetingId;
    this.meetingName = this.$route.query.meetingName;
    this.bgUrl = localStorage.getItem('bgUrl')
    //进入页面打开摄像头
    this.allLists();
    // if (this.timeClock) {
    //   clearInterval(this.timeClock);
    // } else {
    //   this.timeClock = setInterval(() => {
    //     this.getMeetModels();
    //   }, 2000);
    // }
    //人脸识别
    // The getUserMedia interface is used for handling camera input.
    // Some browsers need a prefix so here we're covering all the options
    window.navigator.getUserMedia =
      navigator.getUserMedia ||
      navigator.mediaDevices.getUserMedia ||
      navigator.webkitGetUserMedia ||
      navigator.mozGetUserMedia ||
      navigator.msGetUserMedia;
    this.init();
  },

  destroyed() {
    //退出页面关闭摄像头
    this.videocodeEl.srcObject = null;
    if (this.meetingtimer) {
      clearInterval(this.meetingtimer);
    }
    // if (this.timeClock) {
    //   clearInterval(this.timeClock);
    // }
  }
};
</script>

<style lang="less" scoped>
.bg {
  // position: fixed;
  // top: 0;
  // bottom: 0;
  // left: 0;
  // right: 0;
  color: #fff;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  // padding: 6% 10%;
  font-size: 36px;
  .bgbody {
    // padding: 5% 0;
    position: fixed;
    top: 10%;
    left: 0;
    right: 0;
    bottom: 0;
    .center {
      width: 50%;
      height: 65%;
      margin: 5% auto;
      background: rgba(255, 255, 255, 0.1);
      padding: 3% 0 1%;
      .faceRegister {
        position: relative;
        height: 100%;
        .header {
          text-align: center;
          font-size: 40px;
          margin-bottom: 5%;
          letter-spacing: 3px;
        }
        .videoBox {
          text-align: center;
          position: relative;
          margin-bottom: 2%;
          img {
            width: 52%;
          }
          .playbox {
            text-align: center;
            position: relative;
            height: 80%;

            .qrline {
              position: absolute;
              left: 50%;
              transform: translate(-50%);
              z-index: 2;
              height: 10px;
              width: 38%;
              background: url(../assets/scanline.png) no-repeat; /*上下扫的线*/
              background-size: 100% 100%;
              /*动画效果*/
              animation: myScan 3s infinite alternate;
              animation-timing-function: linear;
              -webkit-animation: myScan 3s infinite alternate;
              -webkit-animation-timing-function: linear;
              box-shadow: 0 -10px 50px rgba(42, 215, 255, 1);
            }
            @keyframes myScan {
              from {
                top: 10%;
              }
              to {
                top: 85%;
              }
            }

            video {
              position: absolute;
              left: 50%;
              top: 0;
              transform: translate(-50%);
              object-fit: fill;
              border-radius: 15px;
            }
            .qrbg {
              position: absolute;
              left: 50%;
              top: 0;
              transform: translate(-50%);
              object-fit: fill;
              z-index: 10;
              // width: 459px;
              // height: 459px;
            }
            .bg2 {
              left: calc(50%+5px);
              top: 10px;
              bottom: 10px;
            }
          }
        }
        .registerBottom {
          text-align: center;
          font-size: 36px;
        }
      }
    }
  }
}
// @media screen and (max-width: 1440px) {
//     .bg .bgbody{
//         padding: 10% 0;
//         }
// }
</style>



// WEBPACK FOOTER //
// src/components/qrCode.vue